import classNames from "classnames";
import { TransLink } from "components/trans/transLink";
import { graphql } from "gatsby";
import React from "react";
import "./button.scss";

export interface ButtonProps {
  label: string;
  link?: {
    link: string;
  };
  externalLink?: string;
  onClick?: () => void;
}

interface Props extends ButtonProps {
  className?: string;
  data?: any;
  glow?: boolean;
}

const Button: React.FC<Props> = (props) => {
  const renderInner = () => (
    <>
      {props.glow && <div className="button__glow" />}
      <span className="button-label"><i>{props.label}</i></span>
    </>
  );

  if (!!props.link) {
    return (
      <TransLink
        to={props.link.link}
        className={classNames("button", props.className)}
      >
        {renderInner()}
      </TransLink>
    );
  }

  if (!!props.onClick) {
    return (
      <button className={classNames("button", props.className)} onClick={props.onClick}>
        {renderInner()}
      </button>
    );
  }

  return (
    <a
      className={classNames("button", props.className)}
      href={props.externalLink || "#"}
      target="_blank"
      rel="norefferer"
    >
      {renderInner()}
    </a>
  );
};

export default Button;

export const query = graphql`
  fragment ButtonBlock on WpAcfButtonBlock {
    AcfButtonBlock {
      label
      externalLink
      link {
        ... on WpPage {
          link
        }
        ... on WpPost {
          link
        }
        ... on WpBlogPost {
          link
        }
        ... on WpResource {
          link
        }
        ... on WpTeamMember {
          link
        }
      }
    }
  }
`;
